import { render, staticRenderFns } from "./RejectPopup .vue?vue&type=template&id=08eb9048&scoped=true"
import script from "./RejectPopup .vue?vue&type=script&lang=js"
export * from "./RejectPopup .vue?vue&type=script&lang=js"
import style0 from "./RejectPopup .vue?vue&type=style&index=0&id=08eb9048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb9048",
  null
  
)

export default component.exports